import IMWarehouseList from './IMWarehouseList';
export default IMWarehouseList;
